import { useClassNames } from "@/utils/classNames";

import styles from "./LoadingWorm.module.scss";
import { LoadingWormProps } from "./types";

/**
 * LoadingWorm component displays an animated loading indicator with colorful bouncing dots.
 *
 * @param open - Whether the loading worm should be visible
 * @param className - Additional CSS class for styling
 *
 * @returns The rendered LoadingWorm component or null if not open
 *
 * @example
 * ```tsx
 * <LoadingWorm open={isLoading} />
 * ```
 */
const LoadingWorm = ({ open, className }: LoadingWormProps) => {
  const cn = useClassNames(styles, styles["loading-worm"], className);

  if (!open) return null;

  return (
    <div className={cn}>
      <div className={styles["dots"]}>
        {Array(6)
          .fill(null)
          .map((_, i) => (
            <div className={styles["dot"]} key={i} />
          ))}
      </div>
    </div>
  );
};

export { LoadingWorm };
